module.exports = __webpack_public_path__ + "static/img/gaozhonglishi6.9fda8ec3.jpg";